import React from 'react';
interface ReportTableProps {
  columns: {
    key: string;
    label: string;
  }[];
  rows: Record<string, string | number>[];
  maxHeight?: string;
}
const statusStyles: Record<string, string> = {
  Completed: 'bg-emerald-50 text-emerald-700',
  Cleared: 'bg-emerald-50 text-emerald-700',
  Negative: 'bg-emerald-50 text-emerald-700',
  Pending: 'bg-gold-50 text-gold-700',
  Rescheduled: 'bg-gold-50 text-gold-700',
  'Non-Negative': 'bg-gold-50 text-gold-700',
  'No Show': 'bg-rose-50 text-rose-700',
  Denied: 'bg-rose-50 text-rose-700',
  Positive: 'bg-rose-50 text-rose-700',
  Cancelled: 'bg-navy-50 text-navy-500',
  Expired: 'bg-navy-50 text-navy-500'
};
function CellValue({
  value,
  columnKey
}: {
  value: string | number;
  columnKey: string;
}) {
  // Handles both plain keys ("status") and join-namespaced keys ("results.result")
  const leafKey = columnKey.split('.').pop() ?? columnKey;
  const isStatusColumn = ['status', 'result'].includes(leafKey);
  if (isStatusColumn && typeof value === 'string' && statusStyles[value]) {
    return <span className={`inline-flex rounded-full px-2 py-0.5 text-[11px] font-medium ${statusStyles[value]}`} data-id="element-247">
        {value}
      </span>;
  }
  return <>{value ?? '—'}</>;
}
export function ReportTable({
  columns,
  rows,
  maxHeight = 'max-h-[480px]'
}: ReportTableProps) {
  if (rows.length === 0) {
    return <div className="flex h-40 items-center justify-center text-sm text-navy-400" data-id="element-248">
        No records match the current filters.
      </div>;
  }
  return <div className={`overflow-auto thin-scroll ${maxHeight}`} data-id="element-249">
      <table className="w-full min-w-max border-collapse text-left" data-id="element-250">
        <thead className="sticky top-0 z-10" data-id="element-251">
          <tr data-id="element-252">
            {columns.map(col => <th key={col.key} scope="col" className="whitespace-nowrap border-b border-navy-100 bg-navy-50/70 px-4 py-2.5 text-[11px] font-semibold uppercase tracking-wider text-navy-500 backdrop-blur" data-id="element-253">
                {col.label}
              </th>)}
          </tr>
        </thead>
        <tbody className="divide-y divide-navy-50" data-id="element-254">
          {rows.map((row, i) => <tr key={i} className="bg-white transition-colors hover:bg-navy-50/40" data-id="element-255">
              {columns.map(col => <td key={col.key} className="whitespace-nowrap px-4 py-2.5 text-sm text-navy-800" data-id="element-256">
                  <CellValue value={row[col.key]} columnKey={col.key} data-id="element-257" />
                </td>)}
            </tr>)}
        </tbody>
      </table>
    </div>;
}